<script lang="ts">
export interface FlashMessage {
  message: string
  type?: 'notice' | 'alert'
  duration?: number | 'permanent'
  id?: string
}
</script>

<script setup lang="ts">
import { useDocumentVisibility } from '@vueuse/core'
import { removeMessage } from '@shared/stores/flash'
import { faCircleExclamation, faCircleInfo, faClose } from '@fortawesome/pro-solid-svg-icons'

const { id, type = 'notice', message, duration = 'permanent' } = defineProps<FlashMessage>()

const isAlert = $computed(() => type === 'alert')

const icon = $computed(() => isAlert ? faCircleExclamation : faCircleInfo)
const iconColor = $computed(() => isAlert ? 'text-red-base' : 'text-v2-active')

const visibility = $(useDocumentVisibility())

if (duration !== 'permanent') {
  watchEffect(() => {
    if (visibility === 'visible')
      setTimeout(hideMessage, duration)
  })
}

function hideMessage () {
  removeMessage(id!)
}
</script>

<template>
  <div class="flash-message inline-flex rounded-lg bg-white shadow-v2lg p-4 flex items-center">
    <GIcon :icon="icon" class="mr-4" :class="iconColor" size="md"/>
    <span class="grow mr-4 whitespace-pre-wrap font-medium">{{ message }}</span>
    <GIconButton class="-mx-2" :icon="faClose" label="Close Message" @click="hideMessage"/>
  </div>
</template>

<style scoped lang="scss">
.flash-message {
  max-width: min(100%, 70ch);
  width: max-content;
}
</style>
